<article [class.is-menu]="isMainSection">
  <aside>
    <h1>
      <a class="main-link" routerLink="/settings">
        <mat-icon>settings</mat-icon>
        Settings
      </a>
    </h1>

    <ng-template #settingsLink let-section="section" let-parentSection="parentSection">
      <ng-container *ngIf="section.externalUrl">
        <ng-container *ngIf="section.openInNewTab">
          <a target="_blank" [href]="section.externalUrl">
            <span [innerHTML]="section.icon | trustHtml"></span>
            {{section.label}}
          </a>
        </ng-container>
        <ng-container *ngIf="!section.openInNewTab">
          <a [href]="section.externalUrl">
            <span [innerHTML]="section.icon | trustHtml"></span>
            {{section.label}}
          </a>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="!section.externalUrl && section.action">
        <a href="javascript:;" (click)="section.action()">
          <span [innerHTML]="section.icon | trustHtml"></span>
          {{section.label}}
        </a>
      </ng-container>
      <ng-container *ngIf="!section.externalUrl && !section.action">
        <ng-container *ngIf="section.defaultSubPage">
          <a
            routerLink="/settings/{{parentSection ? parentSection.id + '/' : ''}}{{section.id}}/{{section.defaultSubPage}}">
            <span [innerHTML]="section.icon | trustHtml"></span>
            {{section.label}}
          </a>
        </ng-container>
        <ng-container *ngIf="!section.defaultSubPage">
          <a routerLink="/settings/{{parentSection ? parentSection.id + '/' : ''}}{{section.id}}">
            <span [innerHTML]="section.icon | trustHtml"></span>
            {{section.label}}
          </a>
        </ng-container>
      </ng-container>
    </ng-template>

    <ul>
      <ng-container *ngFor="let section of sections">
        <li *ngIf="!section.hidden || mainSectionId === section.id" [class.active]="mainSectionId === section.id">
          <ng-container *ngTemplateOutlet="settingsLink; context: {section:section}"></ng-container>

          <ul *ngIf="section.subpages && section.subpages.length > 0">
            <ng-container *ngFor="let subpage of section.subpages">
              <li *ngIf="!subpage.hidden || secondarySectionId === subpage.id"
                [class.active]="secondarySectionId === subpage.id">
                <ng-container *ngTemplateOutlet="settingsLink; context: {section:subpage, parentSection: section}">
                </ng-container>
              </li>
            </ng-container>
          </ul>
        </li>
      </ng-container>
    </ul>
  </aside>
  <div class="page">
    <h2>
      <span class="mobile-breadcrumb">
        <a routerLink="/settings">
          <mat-icon>settings</mat-icon>
          Settings
        </a>
        &raquo;
      </span>
      <ng-container *ngIf="section">{{section.label}}</ng-container>
      <ng-container *ngIf="secondarySection">
        &raquo; {{secondarySection.label}}
      </ng-container>
    </h2>

    <ng-container *ngIf="!sectionReady">
      <app-spinner></app-spinner>
    </ng-container>

    <ng-container *ngIf="sectionReady">
      <ng-container *ngIf="sectionId === 'profile'">
        <app-profile [user]="user" (saved)="afterProfileSave()"></app-profile>
      </ng-container>
      <ng-container *ngIf="sectionId === 'account/change-username'">
        <ng-container *ngIf="!user">
          <app-spinner></app-spinner>
        </ng-container>
        <ng-container *ngIf="user">
          <app-form (submit)="changeUsername()">
            <div style="text-align:center;" *ngIf="submitting">
              Saving your username...
              <app-spinner></app-spinner>
            </div>
            <ng-container *ngIf="!submitting">
              <ng-container *ngIf="user.username">
                Looks like your username is already set! It is:

                <h1>{{user.username}}</h1>

                If you need to change it we may be able to help. Please contact TYT Support
                at support@tytnetwork.com.
              </ng-container>

              <ng-container *ngIf="!user.username">
                <p>Choose carefully! Once you've set your TYT username, it cannot be changed.</p>
                <div class="alert alert-danger" *ngIf="usernameError">
                  {{usernameError}}
                </div>
                <div>
                  <label class="key">Username:</label>
                  <input type="email" name="username" [(ngModel)]="newUsername" />
                </div>

                <br />

                <button class="btn-2">Save</button>
                <a class="btn-2 btn-cancel" routerLink="/settings/account">Cancel</a>

              </ng-container>
            </ng-container>
          </app-form>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="sectionId === 'account/change-email'">
        <app-form (submit)="changeEmail()">

          <div style="text-align:center;" *ngIf="submitting">
            Changing your email address...
            <app-spinner></app-spinner>
          </div>
          <ng-container *ngIf="!submitting">
            <div class="alert alert-danger" *ngIf="emailError">
              {{emailError}}
            </div>
            <div>
              <label class="key">Current Email:</label>
              {{user?.email}}
            </div>
            <div>
              <label class="key">New Email:</label>
              <input type="email" name="email" [(ngModel)]="newEmail" />
            </div>
            <div>
              <label class="key">Confirm Email:</label>
              <input type="email" name="email2" [(ngModel)]="newEmail2" />
            </div>
            <button class="btn-2">Save</button>
            <a class="btn-2 btn-cancel" routerLink="/settings/account">Cancel</a>
          </ng-container>
        </app-form>
      </ng-container>
      <ng-container *ngIf="sectionId === 'account/change-password'">
        <app-form class="change-password" (submit)="changePassword()">
          <div style="text-align:center;" *ngIf="submitting">
            <app-spinner></app-spinner>
            Changing your password...
          </div>
          <ng-container *ngIf="!submitting && user">
            <div class="alert alert-danger" *ngIf="passwordError">
              {{passwordError}}
            </div>

            <input type="text" style="display: none;" autocomplete="username" [(ngModel)]="user.email" />
            <div *ngIf="!user.missing_password">
              <label class="key">Current Password:</label>
              <input type="password" name="currentPassword" [(ngModel)]="currentPassword"
                autocomplete="current-password" />
            </div>
            <div>
              <label class="key">New Password:</label>
              <input type="password" name="newPassword" [(ngModel)]="newPassword" autocomplete="new-password" />
            </div>
            <div>
              <label class="key">Confirm Password:</label>
              <input type="password" name="confirmPassword" [(ngModel)]="newPassword2" autocomplete="new-password" />
            </div>
            <button class="btn-2">Save</button>
            <a class="btn-2 btn-cancel" routerLink="/settings/account">Cancel</a>
          </ng-container>
        </app-form>
      </ng-container>

      <ng-container *ngIf="sectionId === 'account'">
        <tyt-account-settings></tyt-account-settings>
      </ng-container>
      <ng-container *ngIf="sectionId === 'notifications'">
        <tyt-notifications-settings></tyt-notifications-settings>
      </ng-container>
      <ng-container *ngIf="sectionId === 'newsletters'">
        <app-communication-preference></app-communication-preference>
      </ng-container>
      <ng-container *ngIf="sectionId === 'content'">

        <ng-container *ngIf="!onboarding || !user">
          <div>
            Follow topics, shows, hosts, and politicians you are interested in
            to customizing your experience on TYT.com
          </div>
          <div class="submit-step">
            <a class="btn-2" routerLink="/settings/content/topics">Change Follows</a>
          </div>
        </ng-container>
        <ng-container *ngIf="onboarding && user">
          <div>
            Personalize your experience by following topics, hosts, shows
            and politicians!
          </div>

          <div class="submit-step">
            <a class="btn-2" routerLink="/settings/content/topics">Get Started</a>
          </div>
        </ng-container>

      </ng-container>
      <ng-container *ngIf="sectionId === 'content/topics'">
        <div class="onboarding-c2a" *ngIf="onboarding && user">
          <mat-icon>info</mat-icon>
          <div>
            Welcome to your tailored content feed! Select what interests you most, and you’ll see favorites on all TYT
            platforms when logged in.
          </div>
        </div>

        <app-spinner *ngIf="savingTopics"></app-spinner>

        <ng-container *ngIf="!savingTopics">
          <tyt-topic-selector [availableTopics]="categoryTopics" [(followedTopics)]="followedCategoryTopics">
          </tyt-topic-selector>

          <div class="submit-step">
            <button type="button" (click)="saveCategoryTopics()" class="btn-2">Save &amp; Take Me to Shows</button>
          </div>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="sectionId === 'content/done'">
        <div class="done-container">

          <div class="done-alert-box">
            <div class="done-alert-bordered">
              <mat-icon>check_box</mat-icon>
              <div>
                <strong>Your content feed settings are now saved</strong>

                <p>
                  You may add or remove favorites at any time. Selected content will be shown on all
                  devices you are logged into.
                </p>
              </div>
            </div>

            <a routerLink="/home" class="btn-2">Go to Home Page</a><br />
            <a routerLink="/settings/content/topics" class="btn-2 btn-cancel">Redo</a>
          </div>

        </div>
      </ng-container>

      <ng-container *ngIf="sectionId === 'memberships-settings'">
        <iframe #membershipSettingsIframe class="accounts-subframe" [src]="membershipSettingsUrl"></iframe>
      </ng-container>

      <ng-container *ngIf="sectionId === 'memberships'">
        <iframe #accountsIframe class="accounts-subframe" [src]="membershipAccountUrl"></iframe>
      </ng-container>

      <ng-container *ngIf="sectionId === 'terms'">
        <iframe #accountsIframe class="accounts-subframe" [src]="termsUrl"></iframe>
      </ng-container>

      <ng-container *ngIf="sectionId === 'privacy'">
        <iframe #accountsIframe class="accounts-subframe" [src]="privacyUrl"></iframe>
      </ng-container>

      <ng-container *ngIf="sectionId === 'one-time-contribution'">
        <iframe #accountsIframe class="accounts-subframe" [src]="oneTimeContributionUrl"></iframe>
      </ng-container>

      <ng-container *ngIf="sectionId === 'content/shows'">

        <app-spinner *ngIf="savingTopics"></app-spinner>
        <ng-container *ngIf="!savingTopics">
          <tyt-topic-selector [availableTopics]="showTopics" [(followedTopics)]="followedShowTopics">
          </tyt-topic-selector>

          <div class="submit-step">
            <button type="button" [disabled]="!topics" (click)="saveShowTopics()" class="btn-2">Save &amp; Take Me to
              Hosts</button>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="sectionId === 'content/hosts'">

        <app-spinner *ngIf="savingTopics"></app-spinner>
        <ng-container *ngIf="!savingTopics">
          <tyt-topic-selector [availableTopics]="hostTopics" [(followedTopics)]="followedHostTopics">
          </tyt-topic-selector>
          <div class="submit-step">
            <button type="button" [disabled]="!topics" (click)="saveHostTopics()" class="btn-2">Save Preferences &amp;
              Finish</button>
          </div>
        </ng-container>

      </ng-container>
      <ng-container *ngIf="sectionId === 'content/politicians'">

        <app-spinner *ngIf="savingTopics"></app-spinner>
        <ng-container *ngIf="!savingTopics">
          <tyt-topic-selector [availableTopics]="politicianTopics" [(followedTopics)]="followedPoliticianTopics">
          </tyt-topic-selector>

          <div class="submit-step">
            <button type="button" [disabled]="!topics" (click)="savePoliticianTopics()" class="btn-2">Save Preferences
              &amp; Finish</button>
          </div>
        </ng-container>

      </ng-container>
      <ng-container *ngIf="sectionId === 'content/candidates'">

        <app-spinner *ngIf="savingTopics"></app-spinner>


        <ng-container *ngIf="!savingTopics">
          <tyt-topic-selector [availableTopics]="candidateTopics" [(followedTopics)]="followedCandidateTopics">
          </tyt-topic-selector>


          <div class="submit-step">
            <button type="button" [disabled]="!topics" (click)="saveCandidateTopics()" class="btn-2">Save Preferences
              &amp; Finish</button>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="sectionId === 'faq'">
        This is the Membership FAQ page
      </ng-container>
    </ng-container>
  </div>
</article>
